export const loadingActions = {
  ADD: 'add',
  DELETE: 'delete',
  EDIT: 'edit',
  GET: 'get',
  GET_TYPES: 'getTypes',
};

const electronicEquipmentActionTypes = {
  ADD_ELECTRONIC_EQUIPMENT: "ELECTRONIC_EQUIPMENT/CREATE",
  DELETE_ELECTRONIC_EQUIPMENT: "ELECTRONIC_EQUIPMENT/DELETE",
  EDIT_ELECTRONIC_EQUIPMENT: "ELECTRONIC_EQUIPMENT/EDIT",
  GET_ELECTRONIC_EQUIPMENT_TYPES: "ELECTRONIC_EQUIPMENT/GET_TYPES",
  GET_ELECTRONIC_EQUIPMENT_DATA: "ELECTRONIC_EQUIPMENT/GET_DATA",
  RESTORE_INITIAL_STATE: 'ELECTRONIC_EQUIPMENT/RESTORE_INITIAL_STATE',
  SET_ELECTRONIC_EQUIPMENT_SEARCH_FILTERS: "ELECTRONIC_EQUIPMENT/SET_FILTERS",
};

export default electronicEquipmentActionTypes;